import React, { useEffect, useState, useContext, useRef } from "react";

import { Link, useLocation } from "react-router-dom";

import { Card } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";

import AddIcon from "@mui/icons-material/Add";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import CloseIcon from "@mui/icons-material/Close";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import EditIcon from "@mui/icons-material/Edit";
import PeopleIcon from "@mui/icons-material/People";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiAvatar from "components/SuiAvatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import Avatar from "@mui/material/Avatar";

import SuiBadge from "components/SuiBadge";

import Prompt from "components/UpStyled/Prompt";
import api from "services/api";
import toast from "react-hot-toast";

import defaultStyleImage from "assets/images/upstyled/default_background.png";
import CrownIcon from "components/Icon/CrownIcon";
import Actionables from "components/UpStyled/Actionables";

const AILabCard = ({
  handleRefresh = () => { },
  handleAILabClick = () => { },
  ailab,
  //collaboratorUsers = [],
  canDelete = true,
  owner = null,
  readOnly = false,
  imgOptions = {},
  cardOptions = {},
}) => {
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [collaborators, setCollaborators] = useState([]);
  const random = new Date().valueOf();

  useEffect(() => {
    if (ailab.id) {
      retrieveCollaborators();
    }
  }, [ailab.id]);

  const retrieveCollaborators = async (type) => {
    if (!ailab.id) {
      return;
    }
  };

  const removeDuplicate = (userList) => {
    let idSet = new Set();
    let filteredList = [];
    for (let i = 0; i < userList.length; i++) {
      if (idSet.has(userList[i].user_id) || !userList[i].user) {
        //
      } else {
        idSet.add(userList[i].user_id);
        filteredList.push(userList[i]);
      }
    }
    return filteredList;
  };

  const renderCollaborators = collaborators.map((member, key) => {
    const imageAlt = `image-${key}`;
    const store = member?.user?.stores?.[0] || {};
    return (
      <Tooltip title={store.name}>
        <SuiAvatar
          key={imageAlt}
          src={store?.metadata?.avatar}
          alt={imageAlt}
          size="xs"
          sx={{
            border: ({ borders: { borderWidth }, palette: { white } }) =>
              `${borderWidth[2]} solid ${white.main}`,
            cursor: "pointer",
            position: "relative",
            ml: -1,

            "&:hover, &:focus": {
              zIndex: "10",
            },
          }}
        />
      </Tooltip>
    );
  });

  const handleDeleteAILab = (e, ailab) => {
    e.stopPropagation();
    setDeleteVisible(true);
  };

  const actions = [
    {
      label: (
        <SuiTypography variant="body1" color="dark">
          Edit
        </SuiTypography>
      ),
      onClick: (e) => handleAILabClick(ailab),
      icon: <EditIcon fontSize={"small"} />,
    },
  ];
  if (canDelete) {
    actions.push({
      label: (
        <SuiTypography variant="body1" color="error">
          Delete
        </SuiTypography>
      ),
      onClick: (e) => handleDeleteAILab(e, ailab),
      icon: <DeleteForeverRoundedIcon fontSize={"small"} />,
    });
  }

  return (
    <SuiBox
      position="relative"
      m={1.5}
      sx={({ palette: { light }, functions: { pxToRem }, borders: { borderRadius } }) => ({
        backgroundColor: light.main,

        padding: pxToRem(20),
        borderRadius: borderRadius.lg,
      })}
    >
      <SuiBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
        <SuiTypography
          variant="h6"
          sx={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            display: "-webkit-box",
            WebkitLineClamp: "1",
            WebkitBoxOrient: "vertical",
          }}
        >
          {ailab.name}
        </SuiTypography>
        {!readOnly ? <Actionables actions={actions} /> : null}
      </SuiBox>
      <Card
        sx={{ px: 2, py: 2 }}
        style={{
          borderRadius: "8px",
          overflow: "hidden",
          width: "100%",
        }}
        {...cardOptions}
      >
        <SuiBox {...imgOptions}>
          <img
            style={{
              borderRadius: "8px",
              height: "auto",
              width: "100%",
              cursor: "pointer",
            }}
            alt={ailab?.img?.name}
            src={ailab?.img?.url ? ailab.img.url + `?random=${random}` : defaultStyleImage}
            onClick={() => handleAILabClick(ailab)}
          />
        </SuiBox>
        <SuiBox sx={{ mt: 1 }}>
          {ailab.collection?.title ? (
            <SuiTypography
              variant="h6"
              fontWeight="regular"
              color="text"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: "1",
                WebkitBoxOrient: "vertical",
              }}
            >
              Collection: {ailab?.collection?.title}
            </SuiTypography>
          ) : null}

          <SuiBox display="flex" justifyContent="space-between" alignItems="center">
            <SuiBox display="flex" alignItems="center" color="text">
              {owner ? (
                <>
                  <SuiTypography variant="body1" color="text" sx={{ lineHeight: 0 }}>
                    <CrownIcon size={5} color="text" />
                  </SuiTypography>
                  <SuiTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{owner.name}
                  </SuiTypography>
                </>
              ) : collaborators.length > 0 ? (
                <>
                  <SuiTypography variant="body1" color="text" sx={{ lineHeight: 0 }}>
                    <PeopleIcon fontSize="small" color="text" />
                  </SuiTypography>
                  <SuiTypography variant="button" fontWeight="regular" color="text">
                    &nbsp;{collaborators.length}
                  </SuiTypography>
                </>
              ) : null}
            </SuiBox>
            <SuiBox display="flex">
              {" "}
              <AvatarGroup
                max={12}
                slotProps={{
                  additionalAvatar: {
                    sx: { width: 26, height: 26, fontSize: "12px" },
                    className: "border",
                  },
                }}
              >
                {renderCollaborators}
              </AvatarGroup>
            </SuiBox>
          </SuiBox>
        </SuiBox>
        {deleteVisible ? (
          <Prompt
            heading="Delete AILab"
            text={
              <SuiTypography variant="h6" fontWeight="regular">
                {ailab?.collection?.id ? (
                  <span>
                    This ailab belongs to collection:{" "}
                    <SuiTypography variant="h6" color="warning" component="span">
                      {ailab?.collection?.title}.
                    </SuiTypography>
                    <br />
                  </span>
                ) : null}
                Are you sure you want to delete ailab: {ailab.name}?{" "}
              </SuiTypography>
            }
            visible={deleteVisible}
            okText="Delete"
            okColor="error"
            handleOk={() =>
              api.ailab
                .delete(ailab.id)
                .then(() => {
                  toast.success(`Delete ailab ${ailab.name} successfully!`);
                  handleRefresh();
                  setDeleteVisible(false);
                })
                .catch((err) => {
                  console.log(err);
                  toast.error(`Delete ailab ${ailab.name} failed!`);
                })
            }
            handleClose={() => setDeleteVisible(false)}
          />
        ) : null}
      </Card>
    </SuiBox>
  );
};

export default AILabCard;
